import { Suspense, lazy } from "react";

export interface QueryBuilderDrawerI {
  open: boolean;
  close: () => void;
}

const QueryBuilderDrawerComponent = lazy(
  () => import("./QueryBuilderDrawerComponent")
);

export default function QueryBuilderDrawer(props: QueryBuilderDrawerI) {
  return (
    <Suspense fallback={<></>}>
      <QueryBuilderDrawerComponent {...props} />
    </Suspense>
  );
}
